import React from "react";
import styled from "styled-components";

/** The card above the list, laid out as the drop dashboard's Breakdown: a one-line header, then its parts side by side. */
export default function Breakdown({ subtitle, children }) {
    return (
        <Card aria-labelledby="breakdown-heading">
            <Head>
                <Title id="breakdown-heading">Breakdown</Title>
                <Subtitle>{subtitle}</Subtitle>
            </Head>
            <Parts>{children}</Parts>
        </Card>
    );
}

const Card = styled.section`
    overflow: hidden;
    margin-bottom: 22px;
    border: 1px solid #e4e7ec;
    border-radius: 12px;
    background: #fff;
    @media (max-width: 600px) { border-radius: 0; border-left: none; border-right: none; }
`;

const Head = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 10px;
    padding: 10px 20px;
    border-bottom: 1px solid #e4e7ec;
    @media (max-width: 600px) { padding: 10px 16px; }
`;

const Title = styled.h2`
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #0f1419;
`;

const Subtitle = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: #5a6473;
`;

const Parts = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    > * + * { border-left: 1px solid #e4e7ec; }
    @media (max-width: 1000px) {
        grid-template-columns: minmax(0, 1fr);
        > * + * { border-left: none; border-top: 1px solid #e4e7ec; }
    }
`;
